import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SweetAlertService from "../../../../services/SweetAlertService";
import WorkHourService from "../../Shared/Services/WorkHourService";
import { WorkHourDetails } from "../Models/workHour";

export const ViewWorkHourDetails = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [workHourDetails, setWorkHourDetails] = useState<WorkHourDetails>();

    useEffect(() => {
        getWorkhourDetailsBuID();
    }, []);

    const getWorkhourDetailsBuID = () => {
        WorkHourService.getWorkHourDetailsById(Number(id)).then((response: any) => {
            setWorkHourDetails(response.data);
        }).catch(() => {
            SweetAlertService.error("Error", `Something went wrong while getting session rate by id ${id}`);
        })
    }

    return (
        <div className="card card-default">
            <div className="card-header">
                <h4>Session rate details</h4>
            </div>
            <div className="card-body">
                <div className="form-group row">
                    <label className="col-sm-3 control-label"><b>Work Hour Type</b></label>
                    <div className="col-sm-9">
                        {workHourDetails?.workHourTypeName}
                    </div>
                </div>
                <br />
                <div className="form-group row">
                    <label className="col-sm-3 control-label"><b>Start Time</b></label>
                    <div className="col-sm-9">
                        {workHourDetails?.startTime}
                    </div>
                </div>
                <br />
                <div className="form-group row">
                    <label className="col-sm-3 control-label"><b>End Time</b></label>
                    <div className="col-sm-9">
                        {workHourDetails?.endTime}
                    </div>
                </div>
                <br />
                <div className="form-group row">
                    <label className="col-sm-3 control-label"><b>Session Length</b></label>
                    <div className="col-sm-9">
                        {workHourDetails?.sessionLength}
                    </div>
                </div>
                <br />
                <div className="form-group row">
                    <div className=" col-sm-offset-3">
                        <a className="btn btn-secondary"
                            onClick={() => navigate('/workhourDetails/' + workHourDetails?.workHourId)}>
                            Back
                        </a>
                        <button className="btn btn-primary ms-1"
                            onClick={() => navigate(`/updateWorkhourDetails/${workHourDetails?.id}`)}
                            type="button">
                            Edit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}